import { useInfiniteQuery } from '@tanstack/react-query';

import type { Channel } from '~/domains/commissioner/interfaces/channel.interface';
import { getCommissionerPosts } from '~/services/commissioner/commissioner-service.service.api';

const POSTS_TO_FETCH = 5;

type QueryPostsOptions = {
  channel: Channel;
  showPosts: boolean;
  modalOpened: boolean;
  contestId?: string | null;
  enabled?: boolean;
};

const useQueryPosts = ({
  channel,
  showPosts,
  modalOpened,
  contestId = null,
  enabled = true,
}: QueryPostsOptions) => {
  const {
    data: posts,
    fetchNextPage,
    hasNextPage,
    isInitialLoading,
  } = useInfiniteQuery({
    queryKey: ['commissioner/posts', channel?.id, contestId],
    enabled: !!channel && showPosts && !modalOpened && enabled,
    queryFn: ({ pageParam = 1 }) =>
      getCommissionerPosts(channel?.id, {
        page: pageParam,
        pageSize: POSTS_TO_FETCH,
        ...(contestId && { contestId }),
      }),
    getNextPageParam: ({ totalPages, page }) => {
      if (page < totalPages) {
        return page + 1;
      }
    },
  });

  return {
    posts,
    fetchNextPage,
    hasNextPage,
    isInitialLoading,
  };
};

export default useQueryPosts;
